import React from "react";
import { RiShoppingCartLine } from "react-icons/ri";
import useOrganizationIsAllowed from "../../../helpers/organizationPrevillages";
import { useSelector } from "react-redux";
import { FaCheckCircle } from "react-icons/fa";

const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;

const ProductItem = ({
  className,
  item,
  currency,
  checkout,
  selected,
  imageRef,
  handleClick,
  multiSelected,
}) => {
  const { id: branch_id } = useSelector((state) => state.branchReducer.value);
  const orgIsAllowedToManageStock =
    useOrganizationIsAllowed("stock_management");

  const stockDetails = item?.branch_stocks?.find(
    (el) => el?.branch_id === branch_id
  );

  const current_stock = stockDetails ? stockDetails?.current_stock : "";
  const min_quantity = stockDetails ? stockDetails?.min_quantity : "";
  return (
    <div className={`product-item ${className}`} onClick={handleClick}>
      <div className="image" ref={imageRef || null}>
        <p>{`${item?.name}`.length > 0 ? `${item?.name}`[0] : "P"}</p>
        {item?.image && (
          <img
            src={`${item.image}`}
            alt="" aria-label={`${item?.name || "Product"}'s Image`}
          />
        )}
      </div>
      <div className="content">
        <div className="details">
          <p className="name">{item?.name}</p>
          {orgIsAllowedToManageStock.exists && (
            <p className={`stock ${current_stock < min_quantity && "out"}`}>
              Stock: {current_stock}{" "}
              {current_stock < min_quantity && `(Min: ${min_quantity})`}
            </p>
          )}
        </div>
        <p className="price">
          {parseFloat(item?.reduced_price) > 0 ? (
            <>
              <span>{`${currency}${item?.price}`}</span>{" "}
              {`${currency}${item?.reduced_price}`}
            </>
          ) : (
            <>{`${currency}${item?.price}`}</>
          )}
        </p>
        {checkout && selected && (
          <p className="shopping-cart-icon">
            <RiShoppingCartLine />
          </p>
        )}
        {multiSelected && (
          <p className="shopping-cart-icon">
            <FaCheckCircle />
          </p>
        )}
      </div>
    </div>
  );
};

export default ProductItem;
